import { useEffect, useState } from "react";
import { FaChevronDown, FaChevronRight, FaCog, FaHome } from "react-icons/fa";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Scrollbars } from "rc-scrollbars";
import logo from "../../assets/images/logo-white.png";

// import images
import Collapse from "./../../assets/images/hamburger.png";
import { PiSignOut } from "react-icons/pi";
import { useSelector } from "react-redux";
import { getRemindersLinks } from "../../services/authService";
import { StarOutlined } from "@ant-design/icons";

const SideBar = () => {
  const location = useLocation();
  const [collapseMenu, setCollapseMenu] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const { email, is_slack_connected, is_team_connected } = useSelector(
    (state) => state.auth
  );
  const [reminderLinks, setReminderLinks] = useState({
    teams: "#",
    slack: "#",
  });

  useEffect(() => {
    getRemindersLinks(email).then((res) => {
      setReminderLinks({
        teams: `https://teams.microsoft.com/l/app/${process.env.REACT_APP_TEAMS_APP_ID}?source=app-details-dialog`,
        slack: res,
      });
    });
  }, [email]);

  return (
    <div className="vh-100 position-relative bg-primary side-menu">
      <div className="d-flex w-100 align-items-center justify-content-between py-4 my-lg-3 d-lg-flex d-none">
        {!collapseMenu && (
          <Link to="/" className="ps-3 text-white fw-bold h2">
            <img src={logo} alt="logo" />
          </Link>
        )}
        <Link
          className="px-3"
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setCollapseMenu(!collapseMenu);
          }}
        >
          <img src={Collapse} alt="hamburger" />
        </Link>
      </div>

      <Scrollbars
        autoHide
        autoHeight
        autoHeightMax="calc(100vh - 215px)"
        renderThumbVertical={({ style, ...props }) => (
          <div
            {...props}
            style={{
              ...style,
              backgroundColor: "#CCC", // Change color
              borderRadius: "4px",
            }}
          />
        )}
      >
        <Sidebar
          className="border-0"
          rootStyles={{
            "& .ps-sidebar-container, &.ps-submenu-content": {
              backgroundColor: "transparent !important",
              color: "#CCC",
              fontSize: "1rem",
            },
            "& .ps-sidebar-root": {
              border: "none !important", // This removes the border
            },
            "&.ps-collapsed": {
              width: "50px",
              minWidth: "50px",
              "& .ps-submenu-content .ps-menu-button": {
                paddingLeft: "30px !important",
                paddingRight: "10px",
              },
            },
          }}
          breakPoint="sm"
          collapsed={isMobile || collapseMenu}
        >
          <Menu
            menuItemStyles={{
              button: {
                [`&.ps-active, &:hover`]: {
                  color: "#28BF8D",
                  background: "transparent",
                  fontWeight: 700,
                },
              },
            }}
            renderExpandIcon={({ open }) =>
              open ? (
                <FaChevronDown className="text-sm" />
              ) : (
                <FaChevronRight className="text-sm" />
              )
            }
          >
            <MenuItem
              icon={<FaHome />}
              active={location.pathname === "/dashboard"}
              component={<Link to="/dashboard" />}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              icon={<StarOutlined />}
              active={location.pathname === "/check-in"}
              component={<Link to="/check-in" />}
            >
              Check-In
            </MenuItem>
            <MenuItem
              icon={<FaCog />}
              active={location.pathname === "/settings"}
              component={<Link to="/settings" />}
            >
              Profile Settings
            </MenuItem>
            <MenuItem
              icon={<PiSignOut />}
              active={location.pathname === "/logout"}
              component={<Link to="/logout" />}
            >
              Logout
            </MenuItem>
          </Menu>
        </Sidebar>
      </Scrollbars>

      <div
        className="position-absolute bottom-0 pb-5"
        style={{ fontSize: "1rem" }}
      >
        {!is_slack_connected && (
          <Link
            to={reminderLinks.slack}
            className="d-flex align-items-center gap-2 ps-4 py-2 text-white"
            target="_blank"
          >
            <img
              src="https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png"
              alt="Slack Logo"
              height={20}
            />
            {!collapseMenu && "Add To Slack"}
          </Link>
        )}
        {!is_team_connected && (
          <Link
            to={reminderLinks.teams}
            className="d-flex align-items-center gap-2 ps-4 py-2 text-white"
            target="_blank"
          >
            <img
              src="https://mailmeteor.com/logos/assets/PNG/Microsoft_Office_Teams_Logo_128px.png"
              alt="Teams Logo"
              height={20}
            />
            {!collapseMenu && "Add To Teams"}
          </Link>
        )}
      </div>
    </div>
  );
};

export default SideBar;
